import React, {Component, createRef, cloneElement} from 'react';
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';
import AnimationUtils from '@spothero/utils/animation';
import DOMUtils from '@spothero/utils/dom';
import classNames from 'classnames';
import SHLoader from 'common/loader/SHLoader';

class SearchLayoutMobile extends Component {
    static propTypes = {
        SearchMap: PropTypes.object,
        SpotDetails: PropTypes.object,
        SpotList: PropTypes.object,
        SpotListSearchControls: PropTypes.object,
        SpotListSearchControlsCondensed: PropTypes.object,
        EventList: PropTypes.object,
        QuickFilters: PropTypes.object,
        ToggleButton: PropTypes.object,
        DestinationInfoModalMobile: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.bool,
        ]),
        AlertModal: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        isEvent: PropTypes.bool,
        selectedSpotId: PropTypes.number,
        searchRequestId: PropTypes.string,
        isMobileListViewActive: PropTypes.bool.isRequired,
        showEventList: PropTypes.bool,
        additionalSearchClasses: PropTypes.array,
        switchToListView: PropTypes.func,
    };

    state = {
        showCondensedControls: false,
    };
    _listRef = createRef();

    componentDidMount() {
        this._searchControlsEl = DOMUtils.el('.SpotListSearchControls');
        this._onListThrottle = throttle(this._onListScroll, 500);
    }

    componentWillUnmount() {
        if (this._onListThrottle) {
            this._onListThrottle.cancel();
        }
    }

    _onListScroll = () => {
        this.setState({
            showCondensedControls:
                this._listRef.current.scrollTop >
                this._searchControlsEl.offsetHeight,
        });
    };

    _onEditClick = evt => {
        AnimationUtils.scrollTo(this._listRef.current, 0);
    };

    render() {
        const {
            SearchMap,
            SpotDetails,
            SpotList,
            SpotListSearchControls,
            SpotListSearchControlsCondensed,
            EventList,
            isEvent,
            selectedSpotId,
            searchRequestId,
            isMobileListViewActive,
            QuickFilters,
            ToggleButton,
            DestinationInfoModalMobile,
            AlertModal,
            showEventList,
            additionalSearchClasses,
            switchToListView,
        } = this.props;

        const {showCondensedControls} = this.state;
        const classes = classNames({
            'SpotListContainer-show-condensed-controls': showCondensedControls,
        });

        const searchClasses = classNames(
            'Search',
            ...(additionalSearchClasses ? additionalSearchClasses : []),
            {'Search-list-view': isMobileListViewActive},
            {'Search-map-view': !isMobileListViewActive}
        );
        // this is taking the component passed in with all its props, cloning it and adding the onEditClick prop
        // Cloning is required to keep existing props and add an additional prop
        const CondensedControls = cloneElement(
            SpotListSearchControlsCondensed,
            {
                onEditClick: isMobileListViewActive
                    ? this._onEditClick
                    : switchToListView,
            }
        );

        return (
            <>
                <div className="main" role="main">
                    <div className={searchClasses}>
                        <div className="search-results">
                            {searchRequestId ? (
                                <>
                                    {!isMobileListViewActive && (
                                        <>
                                            <div className="SearchMap-container">
                                                {SearchMap}
                                            </div>
                                            {CondensedControls}
                                            {QuickFilters}
                                        </>
                                    )}
                                    {isMobileListViewActive && (
                                        <div className={classes}>
                                            <div
                                                ref={this._listRef}
                                                className="SpotListContainer"
                                                itemScope={
                                                    isEvent ? true : null
                                                }
                                                itemType={
                                                    isEvent
                                                        ? 'http://schema.org/Event'
                                                        : null
                                                }
                                                onScroll={this._onListThrottle}
                                            >
                                                {SpotListSearchControls}
                                                {SpotList}
                                            </div>
                                            {CondensedControls}
                                        </div>
                                    )}
                                    {ToggleButton}
                                </>
                            ) : (
                                <SHLoader />
                            )}
                        </div>
                        {Boolean(selectedSpotId) && SpotDetails}
                    </div>
                </div>
                {DestinationInfoModalMobile}
                {AlertModal}
                {showEventList && EventList}
            </>
        );
    }
}

export default SearchLayoutMobile;
